import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import AOS from "aos";
import "aos/dist/aos.css";

//Assets
import bgimg from "../../Assets/vrbg.svg";
import card3 from "../../Assets/card3.svg";
import card4 from "../../Assets/card4.svg";
import card5 from "../../Assets/card5.svg";
import card6 from "../../Assets/card6.svg";
import card7 from "../../Assets/card7.svg";
import card8 from "../../Assets/card8.svg";
import card9 from "../../Assets/card9.svg";
import card10 from "../../Assets/card10.svg";

function Features() {
  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 2500,
      easing: "ease",
    });
  }, []);

  useEffect(() => {
    if (inView) {
      let imgData = document.getElementById("bgimg");
      if (imgData != undefined) {
        // console.log(imgData[0].cssText);
        imgData.style.cssText = "visibility:visible; position:fixed";
      }
    } else {
      let imgData = document.getElementById("bgimg");
      if (imgData != undefined) {
        imgData.style.cssText = "visibility:hidden; position: absolute";
      }
    }
  }, [inView]);

  return (
    <div className="productsSection_features" ref={ref}>
      <img id="bgimg" className="imgg" src={bgimg} alt="" />
      <div className="productsSection_features_col1">
        <div id="card1" className="productsSection_features_cards" data-aos="fade-right">
          <div className="productsSection_features_cards_shape">
            <img src={card3} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">Game play and interactivity authoring</div>
            <div className="productsSection_features_cards_description">
              Make engrossing games and compelling experiences that react to your players and viewers in ways they’ll find hard to believe.
            </div>
          </div>
        </div>

        <div id="card3" className="productsSection_features_cards" data-aos="fade-right" data-aos-delay="300">
          <div className="productsSection_features_cards_shape">
            <img src={card5} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">Simulation and effects</div>
            <div className="productsSection_features_cards_description">Create believable human and animal characters, massive-scale reactive environments, and film-quality levels of VFX polish.</div>
          </div>
        </div>

        <div id="card5" className="productsSection_features_cards" data-aos="fade-right" data-aos-delay="300">
          <div className="productsSection_features_cards_shape">
            <img src={card7} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">World building</div>
            <div className="productsSection_features_cards_description">Get tools you need to quickly create, edit, and manage the real-time environment of your dreams. </div>
          </div>
        </div>

        <div id="card7" className="productsSection_features_cards" data-aos="fade-right" data-aos-delay="300">
          <div className="productsSection_features_cards_shape">
            <img src={card10} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">Content</div>
            <div className="productsSection_features_cards_description">Why build everything from scratch when you can get a head start for free? Mark-1 offers easy access to rich content.</div>
          </div>
        </div>
      </div>

      <div className="productsSection_features_col1">
        <div id="card2" className="productsSection_features_cards" data-aos="fade-left" data-aos-delay="300">
          <div className="productsSection_features_cards_shape">
            <img src={card4} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">Animation</div>
            <div className="productsSection_features_cards_description">
              With built-in tools for advanced rigging, character animation, performance capture streaming, and more, you can animate in context.
            </div>
          </div>
        </div>

        <div id="card4" className="productsSection_features_cards" data-aos="fade-left" data-aos-delay="300">
          <div className="productsSection_features_cards_shape">
            <img src={card6} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">Rendering, lighting, and materials</div>
            <div className="productsSection_features_cards_description">Achieve Hollywood-quality visuals right out of the box with unprecedented speed and control.</div>
          </div>
        </div>

        <div id="card6" className="productsSection_features_cards" data-aos="fade-left" data-aos-delay="300">
          <div className="productsSection_features_cards_shape">
            <img src={card8} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">Virtual production</div>
            <div className="productsSection_features_cards_description">Mark-1’s comprehensive virtual production tool set covers everything from previous to final-pixel in-camera VFX. </div>
          </div>
        </div>

        <div id="card8" className="productsSection_features_cards" data-aos="fade-left" data-aos-delay="300">
          <div className="productsSection_features_cards_shape">
            <img src={card9} alt="" />
          </div>
          <div className="productsSection_features_cards_card-back"></div>
          <div className="productsSection_features_cards_card">
            <div className="productsSection_features_cards_title">Developer tools</div>
            <div className="productsSection_features_cards_description">Not all projects are created equal. Customize Mark-1 and extend its functionality to meet your unique needs.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
